import * as glMatrix from 'gl-matrix'

var interactionMode
var deformFunc

function damGL(canvasId, vertexArray, indices, materialColors, colorArray, deformationArray, waterlvl, deformScale, nBetoes) {

    if (nBetoes == undefined)
        nBetoes = 1

    var height = Math.max.apply(Math, vertexArray) - Math.min.apply(Math, vertexArray)

    var zoom = -1.5 * height

    var centroide = [0, 0, 0];
    const lengthDiv3 = vertexArray.length / 3;

    for (let i = 0; i < vertexArray.length; i += 3) {
        centroide[0] += vertexArray[i];
        centroide[1] += vertexArray[i + 1];
        centroide[2] += vertexArray[i + 2];
    }

    centroide[0] /= lengthDiv3;
    centroide[1] /= lengthDiv3;
    centroide[2] /= lengthDiv3; // height value


    for (let i = 0; i < vertexArray.length; i += 3) {
        //move to origin the values of x and z 
        vertexArray[i] -= centroide[0]; //x 
        vertexArray[i + 2] -= centroide[2]; //z
    }

    //shaders text
    var colorText = "uniform vec3 vertColor;"
    var gl_positionText = "gl_Position = mProj * mView * mWorld * vec4(vertPosition, 1.0);"
    var vertDeformText = ""
    var deformScaleText = ""
    if (colorArray !== undefined || deformationArray !== undefined) {
        colorText = "attribute vec3 vertColor;"
        vertDeformText = "attribute vec3 vertDeform;"
        deformScaleText = "uniform float deformScale;"
        gl_positionText = "gl_Position = mProj * mView * mWorld * vec4(vertPosition+(vertDeform*deformScale), 1.0);"
    }
    const vertexShaderText = [
        "precision mediump float;",
        "attribute vec3 vertPosition;",
        vertDeformText,
        deformScaleText,
        colorText,
        "varying vec3 fragColor;",
        "uniform mat4 mWorld;",
        "uniform mat4 mView;",
        "uniform mat4 mProj;",
        "void main()",
        "{",
        "fragColor = vertColor;",
        gl_positionText,
        "}",
    ].join("\n");
    const fragmentShaderText = [
        "precision mediump float;",
        "varying vec3 fragColor;",
        "void main()",
        "{",
        "gl_FragColor = vec4(fragColor, 1.0);",
        "}",
    ].join("\n")

    //context
    const canvas = document.getElementById(canvasId)
    const gl = canvas.getContext("webgl")
    if (!gl) {
        const gl = canvas.getContext("experimental-webgl")
        if (!gl) {
            alert("No WebGL here");
        }
    }
    gl.enable(gl.CULL_FACE)
    gl.enable(gl.DEPTH_TEST)
    const program = gl.createProgram()

    //shaders
    var vertexShader = gl.createShader(gl.VERTEX_SHADER)
    gl.shaderSource(vertexShader, vertexShaderText)
    gl.compileShader(vertexShader)
    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
        alert(gl.getShaderInfoLog(vertexShader))
        return
    }
    gl.attachShader(program, vertexShader)
    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER)
    gl.shaderSource(fragmentShader, fragmentShaderText)
    gl.compileShader(fragmentShader)
    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
        alert(gl.getShaderInfoLog(fragmentShader))
        return
    }
    gl.attachShader(program, fragmentShader)
    gl.linkProgram(program)
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        alert("link failed")
        return
    }
    gl.validateProgram(program)
    if (!gl.getProgramParameter(program, gl.VALIDATE_STATUS)) {
        alert("validate failed")
        return
    }
    gl.useProgram(program)

    //uniforms and attribs
    const uniforms = {}
    const attribs = {}
    uniforms.mWorld = gl.getUniformLocation(program, 'mWorld')
    uniforms.mView = gl.getUniformLocation(program, 'mView')
    uniforms.mProj = gl.getUniformLocation(program, 'mProj')
    uniforms.vertColor = gl.getUniformLocation(program, 'vertColor')
    attribs.vertPosition = gl.getAttribLocation(program, 'vertPosition')
    if (colorArray !== undefined && deformationArray !== undefined) {
        attribs.vertColor = gl.getAttribLocation(program, 'vertColor')
        attribs.vertDeform = gl.getAttribLocation(program, 'vertDeform')
        uniforms.deformScale = gl.getUniformLocation(program, 'deformScale')
    } else {
        uniforms.vertColor = gl.getUniformLocation(program, 'vertColor')
    }

    //matrices
    var worldMatrix = new Float32Array(16)
    var viewMatrix = new Float32Array(16)
    var projMatrix = new Float32Array(16)
    var rotationMatrix = new Float32Array(16)
    glMatrix.mat4.identity(worldMatrix)
    glMatrix.mat4.lookAt(viewMatrix, [centroide[0], centroide[2], zoom], [centroide[0], centroide[2], centroide[1]], [0, 1, 0]) //eye, focus, up
    glMatrix.mat4.perspective(projMatrix, glMatrix.glMatrix.toRadian(40), gl.canvas.width / gl.canvas.height, 0.1, 6.4 * height)
    gl.uniformMatrix4fv(uniforms.mWorld, gl.FALSE, worldMatrix)
    gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
    gl.uniformMatrix4fv(uniforms.mProj, gl.FALSE, projMatrix)

    //initial rotation
    const quat = glMatrix.quat.fromValues(0, 0, 0, 1)
    glMatrix.quat.rotateX(quat, quat, 1.2)
    glMatrix.quat.rotateY(quat, quat, 3.14)
    //glMatrix.quat.rotateZ(quat, quat, 1.5)
    glMatrix.mat4.fromQuat(rotationMatrix, quat)
    glMatrix.mat4.mul(worldMatrix, rotationMatrix, worldMatrix)
    gl.uniformMatrix4fv(uniforms.mWorld, gl.FALSE, worldMatrix)

    //buffers
    const buffers = {}
    if (colorArray !== undefined && deformationArray !== undefined) {
        buffers.colorBuffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, buffers.colorBuffer)
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(colorArray), gl.STATIC_DRAW)
        gl.vertexAttribPointer(attribs.vertColor, 3, gl.FLOAT, gl.FALSE, 0, 0)
        gl.enableVertexAttribArray(attribs.vertColor)
        buffers.deformBuffer = gl.createBuffer()
        gl.bindBuffer(gl.ARRAY_BUFFER, buffers.deformBuffer)
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(deformationArray), gl.STATIC_DRAW)
        gl.vertexAttribPointer(attribs.vertDeform, 3, gl.FLOAT, gl.FALSE, 0, 0)
        gl.enableVertexAttribArray(attribs.vertDeform)
    }
    buffers.vertexBuffer = gl.createBuffer()
    gl.bindBuffer(gl.ARRAY_BUFFER, buffers.vertexBuffer)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(vertexArray), gl.STATIC_DRAW)
    gl.vertexAttribPointer(attribs.vertPosition, 3, gl.FLOAT, gl.FALSE, 0, 0)
    gl.enableVertexAttribArray(attribs.vertPosition)
    buffers.indexBuffer = gl.createBuffer()

    //draw function
    const draw = (colorArray !== undefined && deformationArray !== undefined)
        ?
        (time) => {
            gl.clearColor(0.64, 0.64, 0.64, 1.0)
            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)

            for (let i = 0; i < nBetoes; i++) {
                glMatrix.mat4.lookAt(viewMatrix, [translatedX, translatedY, zoom], [translatedX, translatedY, 0], [0, 1, 0])
                gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)

                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indexBuffer)
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices.triangleIndices[i]), gl.STATIC_DRAW)
                gl.drawElements(gl.TRIANGLES, indices.triangleIndices[i].length, gl.UNSIGNED_SHORT, 0)

                gl.disableVertexAttribArray(attribs.vertColor)

                glMatrix.mat4.lookAt(viewMatrix, [translatedX, translatedY, zoom - zoom / 400], [translatedX, translatedY, 0], [0, 1, 0])
                gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)

                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indexBuffer)
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices.lineIndices[i]), gl.STATIC_DRAW)
                gl.drawElements(gl.LINES, indices.lineIndices[i].length, gl.UNSIGNED_SHORT, 0)

                gl.enableVertexAttribArray(attribs.vertColor)
            }

        }
        :
        (time) => {
            gl.clearColor(0.64, 0.64, 0.64, 1.0)
            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
            glMatrix.mat4.lookAt(viewMatrix, [translatedX, translatedY, zoom], [translatedX, translatedY, 0], [0, 1, 0])
            gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
            for (let i = 0; i < indices.triangleIndices.length; i++) {
                gl.uniform3fv(uniforms.vertColor, materialColors[i])
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indexBuffer)
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices.triangleIndices[i]), gl.STATIC_DRAW)
                gl.drawElements(gl.TRIANGLES, indices.triangleIndices[i].length, gl.UNSIGNED_SHORT, 0)
            }
            glMatrix.mat4.lookAt(viewMatrix, [translatedX, translatedY, zoom - zoom / 400], [translatedX, translatedY, 0], [0, 1, 0])
            gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
            gl.uniform3fv(uniforms.vertColor, [0, 0, 0])
            for (let i = 0; i < indices.lineIndices.length; i++) {
                gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffers.indexBuffer)
                gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices.lineIndices[i]), gl.STATIC_DRAW)
                gl.drawElements(gl.LINES, indices.lineIndices[i].length, gl.UNSIGNED_SHORT, 0)
            }
            glMatrix.mat4.lookAt(viewMatrix, [translatedX, translatedY, zoom], [translatedX, translatedY, 0], [0, 1, 0])
            gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
        }

    //events
    interactionMode = 1
    var lastPosX
    var lastPosY
    var translatedX = centroide[0]
    var translatedY = centroide[2] //the original referential assumes z = height
    var rotatedX = 0
    var rotatedY = 0
    var pointerDown = false
    var executingFrame = false
    gl.canvas.addEventListener('pointerdown', (event) => {
        pointerDown = true
        lastPosX = event.clientX
        lastPosY = event.clientY
    })
    gl.canvas.addEventListener('pointerup', (event) => {
        lastPosX = event.clientX
        lastPosY = event.clientY
        pointerDown = false
    })
    gl.canvas.addEventListener('pointermove', (event) => {
        if (pointerDown) {
            const distanceMovedX = (event.clientX - lastPosX)
            const distanceMovedY = (lastPosY - event.clientY)
            switch (interactionMode) {
                case 1: //rotation
                    glMatrix.quat.set(quat, 0, 0, 0, 1)
                    rotatedX += distanceMovedX / 100
                    rotatedY += distanceMovedY / 100
                    glMatrix.quat.rotateX(quat, quat, distanceMovedY / 100)
                    glMatrix.quat.rotateY(quat, quat, distanceMovedX / 100)
                    glMatrix.mat4.fromQuat(rotationMatrix, quat)
                    glMatrix.mat4.mul(worldMatrix, rotationMatrix, worldMatrix)
                    gl.uniformMatrix4fv(uniforms.mWorld, gl.FALSE, worldMatrix)
                    break
                case 2: //translation
                    translatedX += distanceMovedX
                    translatedY += distanceMovedY
                    glMatrix.mat4.lookAt(viewMatrix, [translatedX, -translatedY, zoom], [translatedX, -translatedY, 0], [0, 1, 0])
                    gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
                    break
                case 3: //zoom 
                    zoom += distanceMovedY
                    glMatrix.mat4.lookAt(viewMatrix, [translatedX, -translatedY, zoom], [translatedX, -translatedY, 0], [0, 1, 0])
                    gl.uniformMatrix4fv(uniforms.mView, gl.FALSE, viewMatrix)
                    break
            }
            lastPosX = event.clientX
            lastPosY = event.clientY
            requestAnimationFrame(draw)
        }
    })

    deformFunc = (def) => {
        gl.uniform1f(uniforms.deformScale, def / deformScale / 10)
        requestAnimationFrame(draw)
    }

    requestAnimationFrame(draw)
}

// rotation = 1; translations = 2; zoom = 3;
function setInteractionMode(mode) {
    interactionMode = mode
}

export { damGL, setInteractionMode, deformFunc }